<template>
  <div>
    <sweet-modal :title="$t('settings_accountThink_GLAccounts_generallLedgerDetailed')" blocking width="1140" ref="modal" class="modal" v-on:close="close">

      <el-row :gutter="20">
        <el-col :span="18" :offset="0"><h4 v-html="`${codeACC ? codeACC : codeACCModal} ${title}`" style="margin-top: 0px;"></h4>
          <el-date-picker
            ref="datepicker"
            popper-class="custom-date-picker"
            size="mini"
            v-model="dates"
            class="datepicker"
            prefix-icon="el-icon-date"
            type="daterange"
            align="center"
            format="d MMM yy"
            :clearable="false"
            value-format="timestamp"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            @change="setFilter"
            :picker-options="pickerOptions"
        />
        </el-col>
        <el-col :span="6" :offset="0" style="text-align: right;"><h4 v-html="`${typeModal} ${type ? type : codeModal}`" style="margin-top: 0px;"></h4></el-col>
      </el-row>

      <div style="position: absolute; top: 40px; right: 40px;">
        <el-dropdown size="mini">
              <span class="el-dropdown-link">
                Report Action<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-printer" @click.native="exportData(2, 6)">PDF</el-dropdown-item>
            <el-dropdown-item icon="fas fa-file-excel" @click.native="exportData(1, 6)">XL
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-s-promotion" @click.native="exportData(3,6)">Email</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
<!--        <el-button-->
<!--          size="mini"-->
<!--          icon="el-icon-printer"-->
<!--          @click="downloadPdf"-->
<!--        ></el-button>-->
<!--        <downloadexcel-->
<!--          class="btn download-excel-button"-->
<!--          :fetch="uploadExcel"-->
<!--          :fields="json_fields"-->
<!--        >-->
<!--          <i class="fas fa-file-excel"></i>-->
<!--        </downloadexcel>-->
      </div>

      <el-table
        :data="data"
        max-height="650"
        stripe
        :empty-text="$t('general_noData')"
        style="width: 935px;">
        <el-table-column
          fixed
          width="120"
          prop="transactionDate"
          :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_date')">
        </el-table-column>
        <el-table-column
          fixed
          width="150"
          :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_refNo')">
          <template slot-scope="scope">
            <strong @click="cellClickID(scope.row)" style="color: #409EFF; cursor: pointer;">{{scope.row.transactionNo}}</strong>
          </template>
        </el-table-column>
        <el-table-column
          prop="transactionCode"
          width="120"
          :label="$t('settings_transactionCode')">
        </el-table-column>
        <el-table-column
          width="120"
          prop="transactionType"
          :label="$t('settings_transactionType')">
      </el-table-column>
        <el-table-column
          prop="transactionDescription"
          width="120"
          align="center"
          :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_description')">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.transactionDescription"
              placement="top"
              title="Description"
              width="400"
              trigger="click"
              :content="scope.row.transactionDescription">
              <el-button size="mini" slot="reference" icon="el-icon-view"></el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          width="200"
          header-align="right"
          :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_debit')">
          <template slot-scope="scope">
            <div v-if="!scope.row.total" style="text-align: right;">{{scope.row.debit ? formatPrice(scope.row.debit) : null}}</div>
            <div v-else style="text-align: right;">{{scope.row.debit ? formatPrice(scope.row.debit) : null}}</div>
          </template>
        </el-table-column>
        <el-table-column
          width="200"
          header-align="right"
          :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_credit')">
          <template slot-scope="scope">
            <div v-if="!scope.row.total" style="text-align: right;">{{scope.row.credit ? formatPrice(scope.row.credit) : null}}</div>
            <div v-else style="text-align: right;">{{scope.row.credit ? formatPrice(scope.row.credit) : null}}</div>
          </template>
        </el-table-column>
        <el-table-column
          width="200"
          header-align="right"
          :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_balance')">
          <template slot-scope="scope">
            <div v-if="!scope.row.total" style="text-align: right;">{{scope.row.balance ? formatPrice(scope.row.balance) : null}}</div>
            <div v-else @click="openSubsidiaryLedgerModal()" style="text-align: right; color: #2b78e4; cursor: pointer;">{{scope.row.balance ? formatPrice(scope.row.balance) : null}}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          width="200"
          header-align="right"
          :label="$t('settings_accountThink_GLAccounts_generallEdgerDetailed_TaxAmt')">
          <template slot-scope="scope">
            <div v-if="!scope.row.total" style="text-align: right;">{{scope.row.vatamt}}</div>
            <div v-else style="text-align: right;">{{formatPrice(scope.row.vatamt)}}</div>
          </template>
        </el-table-column> -->
      </el-table>
    </sweet-modal>
    <general-ledger-detailed-subsidiary-modal
        :params="params"
        :startDate="dates[0]"
        :endDate="dates[1]"
        :title="title"
        :code="codeACC ? codeACC : codeACCModal"
        :type="typeForNextModal"
      ref="generalLedgerSubsidiaryModal"/>

    <editJournalEntryModal @updateList="getList" :showInfo="false" ref="editJournalEntryModal"/>
  </div>
</template>

<script>
import downloadexcel from "vue-json-excel";
import jsPDF from "jspdf";
import {SweetModal} from "@totalflow4/tfsweet-modal-vue";
import { Money, VMoney } from 'v-money'
import axios from 'axios'
import moment from 'moment'
import GeneralLedgerDetailedSubsidiaryModal from "./GeneralLedgerDetailedSubsidiaryModal";
import editJournalEntryModal from '@/components/journalAndGl/editJournalEntryModal.vue'
export default {
  name: "GenerallEdgerDetailedModal",
  components: {
    GeneralLedgerDetailedSubsidiaryModal,
    SweetModal,
    Money,
    editJournalEntryModal,
    downloadexcel,
  },
  directives: {money: VMoney},
  props: {
    currencyList: {
      type: Array,
      default: () => ([])
    },
    startDate: {
      type: String,
      default: null,
    },
    endDate: {
      type: String,
      default: null,
    }
  },
  computed: {
    typeForNextModal() {
      return `${this.typeModal} ${this.type ? this.type : this.codeModal}`
    },
    totalAmount() {
      const amount = this.allocations.map(val => val.amount).reduce((sum, curr) => {
        return !curr ? sum : parseFloat(curr) + sum
      }, 0)
      return amount
    },
    totalAmountForeign() {
      const amount = this.allocations.map(val => val.foreignAmount).reduce((sum, curr) => {
        return !curr ? sum : parseFloat(curr) + sum
      }, 0)
      return amount
    },
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    },
    // currencyForeign() {
    //   return this.currencyList.find(val => val.id === this.params.data.accountCurrencyId)
    // },
    financialYearStartDateFormatted () {
      return this.companyLayout && this.companyLayout.financialYearStartDate ? moment(this.companyLayout.financialYearStartDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : null
    },
  },
  data() {
    const validateAmount = (rule, value, callback) => {
      if (value <= 0) return callback(new Error(this.$t('modal_settings_fieldIsRequired')))
      callback();
    }
    return {
      dates: [],
      moment: moment,
      validateAmount: validateAmount,
      title: '',
      typeModal: '',
      codeModal: '',
      codeACCModal: '',
      type: '',
      codeACC: '',
      data: [],
      state: 'create',
      transactionNo: null,
      money: {
        precision: 2,
        decimal: '.',
        thousands: ',',
        suffix: '',
        masked: false
      },
      moneyForeign: {
        precision: 2,
        decimal: '.',
        thousands: ',',
        suffix: '',
        masked: false
      },
      form2: {
        amount: 0,
        foreignAmount: 0,
        transactionDescription: null,
        items: [
          {
            amount: 0,
            transactionDescription: null,
            // TODO NEW
            entityTypeId: null,
            buId: null,
            parentId: null,
            taskId: null,
            vendorClientTypeId: null,
            vendorId: null,
            clientId: null,
            userId: null,
            // lists
            vendorList: [],
            clientList: [],
            buList: [],
            parentList: [],
            taskList: [],
            userList: []
          }
        ]
      },
      entityTypeList: [
        { id: 1, name: 'Project' },
        { id: 2, name: 'Business Unit' },
        { id: 3, name: 'Engagement' }
      ],
      json_fields: {
        Date: "transactionDate",
        ID: "transactionNo",
        Type: "transactionCode",
        Description: "transactionDescription",
        Debit: "debit",
        Credit: "credit",
        Balance: "balance",
        Tax: "vatamt",
      },
      // vendorClientList: [
      //   { id: 'vendor', name: 'Vendor' },
      //   { id: 'client', name: 'Client' }
      // ],
      // rules: {
      //   amount:[{
      //     required: true,
      //     message: this.$i18n.t('modal_settings_fieldIsRequired'),
      //     trigger: 'blur'
      //   }]
      // },
      params: {
        data: {
          id: null,
          name: '',
          DRCRCode: 'DR',
          accountCurrencyId: null
        }
      },
      item: [],
      allocations: [],
      pickerOptions: {
        shortcuts: [
          {
            text: 'This month',
            onClick (picker) {
              const end = moment().endOf('month')
              const start = moment().startOf('month')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'Last month',
            onClick (picker) {
              const end = moment().endOf('month').subtract(1, 'months')
              const start = moment().startOf('month').subtract(1, 'months')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'Last 3 months',
            onClick (picker) {
              const end = moment().endOf('month').subtract(1, 'months')
              const start = moment().startOf('month').subtract(3, 'months')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'This financial quarter',
            onClick (picker) {
              const end = moment().endOf('quarter')
              const start = moment().startOf('quarter')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'Last financial quarter',
            onClick (picker) {
              const end = moment().subtract(1, 'quarter').endOf('quarter')
              const start = moment().subtract(1, 'quarter').startOf('quarter')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'This financial year',
            onClick (picker) {
              const end = moment().endOf('year')
              const start = moment().startOf('year')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'Last financial year',
            onClick (picker) {
              const end = moment().endOf('year').subtract(1, 'year')
              const start = moment().startOf('year').subtract(1, 'year')
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  methods: {
    setFilter (val) {
      this.itemTest()
    },
    downloadPdf() {
      let loader = this.$loading.show();

      const table = this.data;

      loader.hide();

      let pdfName = `${Math.floor(Date.now() / 1000)}`;
      const doc = new jsPDF("l", "pt", "a4");

      const body = [];
      table.forEach((val, index) => {
        const item = [val.transactionDate, val.transactionNo, val.transactionCode, val.transactionDescription, val.debit, val.credit, val.balance, val.vatamt];
        body.push(item);
      });

      doc.autoTable({
        bodyStyles: { fontSize: 7 },
        margin: { top: 5, left: 5, right: 5, bottom: 0 },
        head: [["Date", "ID", "Type", "Description", "Debit", "Credit", "Balance", "Tax Amt"]],
        body: body,
      });

      doc.output("dataurlnewwindow");
    },
    async uploadExcel() {
      try {
        let loader = this.$loading.show();

        const table = this.data;

        loader.hide();

        return table;
      } catch (err) {
        console.log(err);
      }
    },
    openModal(params) {
      this.dates = [this.startDate, this.endDate]
      // this.dates = [moment(this.startDate).format("x"), moment(this.endDate).format("x")]
      this.title = params.data.name + ' (' + this.companyLayout.currency.code + ')'
      this.codeACC = params.data.code
      this.type = params.data.DRCRCode
      this.params = params
      // eslint-disable-next-line no-console
      console.log('PPPPP', params)
      this.itemTest()
      this.$refs.modal.open()
    },
    // async openModalEdit(params) {
    //   try {
    //     this.state = 'update'
    //     this.money.suffix = ' ' + this.companyLayout.currency.code
    //     this.params = params
    //     this.moneyForeign.suffix = ' ' + this.currencyForeign.code
    //     await this.loadItem()
    //     this.$refs.modal.open()
    //   } catch (err) {
    //     console.log(err)
    //   }
    // },
    openSubsidiaryLedgerModal() {
      this.$refs.generalLedgerSubsidiaryModal.openModal()
    },
    itemTest() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(` api/v1/account/ledger/item?accountId=${this.params.data.id}&startDate=${moment(this.dates[0], 'x').format('YYYY-MM-DD')}&endDate=${moment(this.dates[1], 'x').format('YYYY-MM-DD')}`)
          .then(response => {
            // eslint-disable-next-line no-console
            console.log('RERERERE', response.data.item)
            this.data = response.data.item
            if (response.data.item.length > 0) {
              this.typeModal = response.data.item[0].finDocName
              this.codeModal = response.data.item[0].ADRCRCode
              this.codeACCModal = response.data.item[0].code
            }
            let obj = {
              debit: 0,
              credit: 0,
              balance: 0,
              vatamt: 0,
              total: true,
            }
            let ADRCRCode = ''
            for (let i = 0; i < this.data.length; i++) {
              this.data[i].transactionDate = this.data[i].transactionDate ? moment(this.data[i].transactionDate).format("D MMM YYYY") : '';
              obj.debit = obj.debit + +this.data[i].debit
              obj.credit = obj.credit + +this.data[i].credit
              // obj.vatamt = obj.vatamt + +this.data[i].vatamt
              if (i == 0) { ADRCRCode = this.data[i].ADRCRCode }
            }
            if (ADRCRCode == "CR") {
              obj.balance = +obj.credit - +obj.debit
            } else {
              obj.balance = +obj.debit - +obj.credit
            }
            this.data.push(obj)
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    async loadItem() {
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const item = await axios.get(`/api/v1/accountTransaction/item?accountId=${this.params.data.id}`)
        this.transactionNo = item.data.item[0].transactionNo
        this.item = item.data.item
        this.allocations = item.data.item.filter((val, index) => index > 0)
        this.form2.amount = item.data.item[0].amount
        this.form2.foreignAmount = item.data.item[0].foreignAmount
        this.form2.transactionDescription = item.data.item[0].transactionDescription
        loader.hide()
      } catch(err) {
        console.log(err)
        loader.hide()
      }
    },
    record(form) {
      if (!this.form2.amount || this.form2.amount <= 0) {
        return this.notification("Notification", this.$t('settings_accountThink_GLAccounts_amount') + ' ' + this.$t('modal_settings_fieldIsRequired'), "info")
      }
      this.$refs[form].validate((valid) => {
        if (valid) {
          const payload = {
            amount: parseFloat(this.form2.amount),
            foreignAmount: parseFloat(this.form2.foreignAmount),
            transactionDescription: this.form2.transactionDescription,
            transactionId: 1,
            accountId: this.params.data.id,
            transactionCurrency: this.params.data.name
          }

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/accountTransaction/createOpenBalance?companyId=${this.$route.query.companyId}`, payload)
              .then(response => {
                this.notification(this.$t('general_success'), this.$t('setting_transactionCreated'), "success");
                this.$emit('loadList')
                loader.hide()
                this.state = 'update'
                this.transactionNo = response.data.newTransaction.transactionNo
                // this.$refs.modal.close()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
        }
      })
    },
    close() {
      this.state = 'create'
      this.transactionNo = null
      this.params = {
        data: {
          id: null,
          name: '',
          DRCRCode: 'DR',
          accountCurrencyId: null
        }
      }
      this.money.suffix = ''
      this.moneyForeign.suffix = ''
      this.form2.amount = 0
      this.form2.foreignAmount = 0
      this.form2.transactionDescription = null
      this.allocations = []
      this.item = []
      this.data = []
      this.$emit('closeModal')
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    cellClick(val, column) {
      console.log('cell', val, column)
      if (column.label !== 'Action') {
        this.$refs.allocationsInfoModal.openModal(val)
      }
    },
    cellClickID(row){
      this.$refs['editJournalEntryModal'].openModalFromJournalEntry(row)
    },
    ifTotalAmountBigger() {
      return this.form2.amount < this.totalAmount
    },
    balanceToAllocate() {
      return this.form2.amount - this.totalAmount
    },
    balanceToAllocateForeign() {
      return this.form2.foreignAmount - this.totalAmountForeign
    },
    openSecondaryModal() {
      this.$refs.allocationsModal.openModal()
    },
    closeModal() {
      this.$refs.modal.close()
    },
    deleteAllocation(row) {
      this.$confirm("Delete transaction?", this.$t('general_info'), {
        distinguishCancelAndClose: true,
        confirmButtonText: this.$t('general_ok'),
        cancelButtonText: this.$t('general_cancel'),
        type: 'info'
      }).then(async () => {
        const loader = this.$loading.show();
        await axios.get(`api/v1/accountTransaction/delete?transactionId=${row.id}`)
        await this.loadItem()
        loader.hide()
      }).catch(action => {
        console.log('action', action)
      });
    },
    async exportData (typeExportId, typeId) {
      let email = null
      try {

        if (typeExportId === 3) {
          const { value } = await this.$prompt('Please input your e-mail', '', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            inputErrorMessage: 'Invalid Email'
          })
          email = value
        }
        const payload = {
          companyId: +this.$route.query.companyId,
          typeId: typeId,
          typeExportId: typeExportId,
          // startDate: this.financialYearStartDateFormatted ? this.financialYearStartDateFormatted : '2022-01-01',
          // endDate: moment().format('YYYY-MM-DD'),
          startDate: this.dates && this.dates[0] ? moment(this.dates[0], 'x').format('YYYY-MM-DD') : 'null',
          endDate: this.dates && this.dates[1] ? moment(this.dates[1], 'x').format('YYYY-MM-DD') : 'null',
          email: email,
          optionalField: {
            name: 'accountId',
            value: this.params.data.id.toString()
          }
        }
        let loader = this.$loading.show()
        axios.defaults.headers.common['Authorization'] =
            'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = (
            new Date().getTimezoneOffset() / 60
        ).toString()
        const { data } = await axios.post(`/api/v1/export`, payload)
        switch (typeExportId) {
          case 2: // pdf
          case 1: // xl
            window.open(data.file.downloadPath).focus()
            break
        }
        loader.hide()
      } catch (err) {
        console.log(err)
      }
    },
    getList() {
      this.$emit('getList')
    }
  }
}
</script>

<style lang="less" scoped>
.amount-input {
  display: block;
  resize: vertical;
  padding: 0 15px;
  line-height: 1.5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 200px;
  font-size: inherit;
  color: #606266;
  background-color: #FFF;
  background-image: none;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  //transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  height: 33px;
  &:focus {
    outline: 0;
    border-color: #409EFF;
  }
  &.readonly {
    background: rgba(201, 202, 205, 0.5);
  }
}
.item-amount-input {
  display: block;
  resize: vertical;
  padding: 0 5px;
  line-height: 1.5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  font-size: inherit;
  color: #606266;
  background-color: #FFF;
  background-image: none;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  //transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  height: 33px;
  &:focus {
    outline: 0;
    border-color: #409EFF;
  }
}
</style>

<style lang="less">
.sweet-modal-overlay{
  .sweet-modal {
    max-width: 1000px !important;
  }
}

.sweet-modal-overlay{
  z-index:1000;
}

.btn {
  background-color: #ecf5ff;
  border-color: #d9ecff;
  display: inline-block;
  height: 32px;
  padding: 0 10px;
  line-height: 30px;
  font-size: 12px;
  color: #409eff;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
  cursor: pointer;
  &.add-btn {
    margin-right: 10px;
  }
  &.edit-btn {
    margin-right: 10px;
  }
}

.download-excel-button {
  margin-left: 10px;
  font-size: 12px;
  border-radius: 3px;
  padding: 7px 15px;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  transition: 0.1s;
  font-weight: 500;
  box-sizing: border-box;
  outline: 0;
  &:hover {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
}

</style>
